import { ComparisonType, QueryStatementType } from "reducers/flow-builder.reducer";

export const getOperatorLabel = (operator: string) => {
  switch (operator) {
    case "in_between":
      return "Between";
    case "number_between":
      return "Between";
    case "is_equal":
      return "Is Equal";
    default:
      return operator;
  }
}

export const convertFieldToSegmentStatement = (field: any) => {
  const rangeValue = field.value as unknown as { from: string, to: string }
  if (!field.value) {
    return void 0;
  }
  switch (field.type) {
    case "number_between": {
      const minStatement = {
        key: field.key,
        type: QueryStatementType.ATTRIBUTE,
        value: Number(rangeValue.from),
        valueType: field.valueType,
        comparisonType: ComparisonType.GREATER,
        subComparisonType: field.subComparisonType,
        subComparisonValue: field.subComparisonValue,
        isProductAttribute: field.isProductAttribute,
        isCartAttribute: field.isCartAttribute,
      }
      const maxStatement = {
        key: field.key,
        type: QueryStatementType.ATTRIBUTE,
        value: Number(rangeValue.to),
        valueType: field.valueType,
        comparisonType: ComparisonType.LESS,
        subComparisonType: field.subComparisonType,
        subComparisonValue: field.subComparisonValue,
        isProductAttribute: field.isProductAttribute,
        isCartAttribute: field.isCartAttribute,
      }

      return [minStatement, maxStatement].filter((s) => Boolean(s.value));
    }
    case ComparisonType.DURING: {
      let comparisonType = ComparisonType.DURING;
      let value = rangeValue.from
      if (rangeValue.from && rangeValue.to) {
        comparisonType = ComparisonType.DURING;
      } else if (rangeValue.from) {
        comparisonType = ComparisonType.AFTER;
      } else if (rangeValue.to) {
        comparisonType = ComparisonType.BEFORE;
        value = rangeValue.to;
      } else {
        comparisonType = ComparisonType.DURING;
      }
      const statement = {
        key: field.key,
        type: QueryStatementType.ATTRIBUTE,
        value,
        valueType: field.valueType,
        comparisonType: comparisonType,
        subComparisonType: field.subComparisonType,
        dateComparisonType: field.dateComparisonType,
        subComparisonValue: rangeValue.to,
        isProductAttribute: field.isProductAttribute,
        isCartAttribute: field.isCartAttribute,
      }

      return [statement];
    }
    default:
      return [{
        key: field.key,
        type: QueryStatementType.ATTRIBUTE,
        value: field.value,
        valueType: field.valueType,
        comparisonType: field.comparisonType,
        subComparisonType: field.subComparisonType,
        subComparisonValue: field.subComparisonValue,
        isProductAttribute: field.isProductAttribute,
        isCartAttribute: field.isCartAttribute,
      }]
  }
}


export const checkAndCombiningSubfields = (fields: any[]) => {
  const newFields = [] as any[];
  const subFieldsToCleanUp = [] as string[]
  fields.forEach((rootField: any) => {
    if (!Array.isArray(rootField.subFields)) {
      return newFields.push(rootField);
    }
    const subFields = rootField.subFields || []
    const updatedField = subFields.reduce((originalField: any, subField: any) => {
      const foundField = fields.find(f => f.key === subField.name);
      if (!foundField || !foundField.key) return originalField;
      subFieldsToCleanUp.push(foundField.key)
      return {
        ...originalField,
        [subField.mapToKey || 'value']: foundField.value
      }
    }, rootField)
    newFields.push(updatedField);
  });
  const outResults = newFields.filter((field) => !subFieldsToCleanUp.includes(field.key))
  return outResults
}